module.exports = __webpack_public_path__ + "img/79.d096aa4e.jpg";